import AppHeader from '../../components/AppHeader';
import HomeImage from '../../components/LoginImage';
import React from 'react';
import { notification } from 'antd';
import ForgotPasswordForm from '../../components/forms/ForgotPasswordForm';
import { useSetPageTitle } from '../../utils/hooks';
import './styles.css';

const ForgotPasswordPage = () => {
  useSetPageTitle('Forgot Password');
  const [notificationInstance, contextHolder] = notification.useNotification();
  const popUpNotification = (notificationType, config) => {
    notificationInstance[notificationType]({
      message: config.title,
      description: config.description,
    });
  };

  return (
    <>
      <AppHeader />
      <div className={'login-page'}>
        {contextHolder}
        <HomeImage />
        <div className={'login-container'}>
          <div className={'forgot-password-body'}>
            <h1>Reset password</h1>
            <ForgotPasswordForm popUpNotification={popUpNotification} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
